(() => {
  const numberFormatter = new Intl.NumberFormat('en-AE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const activeFactor = () => Number(window.theme?.priceFactor || 1);
  const formatAed = (amount) => `AED ${numberFormatter.format(Number(amount || 0) * activeFactor())}`;

  window.formatMoney = formatAed;
  window.formatMoneyWithoutConversion = formatAed;
  window.theme = window.theme || {};
  window.theme.money_format = 'AED {{amount}}';
  window.theme.formatMoney = (cents) => formatAed(Number(cents || 0) / 100);
})();
